import React from 'react'
import ShowInstructions from '../components/instructions/ShowInstructions'
import { useTranslation } from 'react-i18next'

const Instructions: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='mt-20'>
      <h1  className='text-center text-3xl mb-4'>{t("Instructions")}</h1>
      <ShowInstructions />
    </div>
  )
}

export default Instructions
